import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelector } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

type Entity = models.LiberacionEntregaZEDTO;
type Column = kea.Grid2Column<Entity>;

/**Columnas fijas del grid */
const columnasFijas: Column[] = [
    { title: "Usuario realizo", cell: x => ({ data: x.NombreUsuario }) },
    { title: "Fecha", cell: x => ({ data: kea.formatDate(x.FechaLiberacion) }) },
    { title: "Proveedor ZE", cell: x => ({ data: x.NombreProveedor }) },
    { title: "Chofer ZE", cell: x => ({ data: x.NombreChoferZE }) },
    { title: "Total FXC", cell: x => ({ data: kea.formatCurrency(x.TotalFXC) }) },
    { title: "Cant. acuses", cell: x => ({ data: x.CantidadAcuses }) },
    { title: "Cant. guias", cell: x => ({ data: x.CantGuias }) },
];

export interface BotonesDeps {
    onVer: (x: Entity) => void;
    onImprimirAcuses: (x: Entity) => void;
}

/**Obtiene las columnas del grid */
export function columnas(deps: BotonesDeps): Column[] {
    const botones = kea.columnaBotones([
        {
            iconClass: fa("print"),
            tooltip: "Imprimir acuses internos",
            onClick: deps.onImprimirAcuses
        }, {
            iconClass: fa("eye"),
            tooltip: "Ver entrega",
            onClick: deps.onVer
        }
    ]);

    return [botones, ...columnasFijas];
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/liberacionentregasZE/components/list/columns.tsx